import React, { createContext, useState, useEffect } from "react";
import { IntlProvider } from "react-intl";

import esMessages from "../i18n/es.json";
import enMessages from "../i18n/en.json";
import caMessages from "../i18n/ca.json";
import frMessages from "../i18n/fr.json";
import ptMessages from "../i18n/pt.json";
import deMessages from "../i18n/de.json";
import fiMessages from "../i18n/fi.json";
import esCgiMessages from "../i18n/es-cgi.json";
import enCgiMessages from "../i18n/en-cgi.json";
import caCgiMessages from "../i18n/ca-cgi.json";
import frCgiMessages from "../i18n/fr-cgi.json";
import ptCgiMessages from "../i18n/pt-cgi.json";
import deCgiMessages from "../i18n/de-cgi.json";
import fiCgiMessages from "../i18n/fi-cgi.json";

const messages = {
    es: esMessages,
    en: enMessages,
    ca: caMessages,
    fr: frMessages,
    pt: ptMessages,
    de: deMessages,
    fi: fiMessages,
    "es-cgi": esCgiMessages,
    "en-cgi": enCgiMessages,
    "ca-cgi": caCgiMessages,
    "fr-cgi": frCgiMessages,
    "pt-cgi": ptCgiMessages,
    "de-cgi": deCgiMessages,
    "fi-cgi": fiCgiMessages,
};

export const LanguageContext = createContext();

export const LanguageProvider = ({ children, variant = '' }) => {
    const [locale, setLocale] = useState("es");
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);

        // Solo ejecutamos este código en el cliente, no durante el SSR
        if (typeof window !== "undefined") {
            const savedLocale = localStorage.getItem("locale") ||
                (navigator.language || navigator.userLanguage).split("-")[0];

            if (savedLocale && messages[savedLocale]) {
                setLocale(savedLocale);
            }
        }
    }, []);

    const changeLanguage = (lang) => {
        // Construir la clave del mensaje según la variante
        const messageKey = variant ? `${lang}-${variant}` : lang;

        if (messages[messageKey]) {
            setLocale(lang); // Guardamos solo el idioma base
            if (typeof window !== "undefined") {
                localStorage.setItem("locale", lang);
            }
        }
    };

    // Determinar qué mensajes usar según la variante
    const getMessages = () => {
        if (!isClient) {
            return variant ? messages[`es-${variant}`] || messages.es : messages.es;
        }

        const messageKey = variant ? `${locale}-${variant}` : locale;
        return messages[messageKey] || messages[locale] || messages.es;
    };

    const currentMessages = getMessages();

    return (
        <LanguageContext.Provider value={{ locale, changeLanguage }}>
            <IntlProvider locale={locale} messages={currentMessages}>
                {children}
            </IntlProvider>
        </LanguageContext.Provider>
    );
};